import { Component } from '@angular/core';
import { Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

interface Input {
    title?: string;
    labelText?: string;
    uploadText?: string;
}

@Component({
    selector: 'upload-profile-image-dialog',
    templateUrl: './upload-profile-image-dialog.component.html',
    styleUrls: ['./upload-profile-image-dialog.component.scss']
})
export class UploadProfileImageDialogComponent {
    public static readonly config: MatDialogConfig<Input> = {
        autoFocus: false,
        disableClose: true,
        width: '400px',
    };
    public static readonly output: File | null;

    public file: File | null = null;

    public constructor(
        private readonly host: MatDialogRef<UploadProfileImageDialogComponent, File | null>,
        @Optional() @Inject(MAT_DIALOG_DATA) private readonly input: Input | null,
    ) { }

    public get title() {
        return this.input?.title ?? 'Upload Profile Image';
    }

    public get labelText() {
        return this.input?.labelText ?? 'Drag and drop a file here or click to browse';
    }

    public get uploadText() {
        return this.input?.uploadText ?? 'Upload';
    }

    public cancel() {
        this.host.close(null);
    }

    public upload() {
        this.host.close(this.file);
    }
}
